import { useMediaQuery, queryHelpers } from "@leagueplatform/genesis-core";

export const useIsBelowTablet = () =>
  useMediaQuery(queryHelpers.down("tablet"));
